import { ecsClient, getGlobalSessionId } from "@/services";
import { RefundStatus } from "@/types/refundProcess";
import {
  RefundWithItem,
  GetUserRefundsResponseDto,
} from "@/types/refundWithItem";

type MarkNotifiedRequest = {
  pk: string;
  sk: string;
};

const getRefundProcessesByStatus = async (
  status: RefundStatus,
  notified: boolean = false
): Promise<RefundWithItem[]> => {
  try {
    const sessionId = getGlobalSessionId();
    const response = await ecsClient.get<GetUserRefundsResponseDto>(
      `/refund/processes`,
      {
        params: { status, notified, sessionId },
      }
    );

    if (response.data.success) {
      return response.data.refunds || [];
    }
    return [];
  } catch (error) {
    console.error("❌ Error fetching refund processes:", error);
    return [];
  }
};

const getApprovedRefundProcesses = async (): Promise<RefundWithItem[]> => {
  try {
    // Fetch approved status with notified=false
    const approved = await getRefundProcessesByStatus("approved", false);
    return approved;
  } catch (error) {
    console.error("Error fetching approved refund processes:", error);
    return [];
  }
};

const markAsNotified = async (
  request: MarkNotifiedRequest
): Promise<boolean> => {
  try {
    const sessionId = getGlobalSessionId();
    const response = await ecsClient.post("/refund/process/mark-notified", {
      ...request,
      sessionId,
    });
    return response.data.success;
  } catch (error) {
    console.error("Error marking refund as notified:", error);
    return false;
  }
};

export {
  getRefundProcessesByStatus,
  getApprovedRefundProcesses,
  markAsNotified,
};
